<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <h4 class="card-title float-left">{{$t('companyManage.companyPersonalCabinet.label')}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>Компания тури:</label>
                                    <label class="color-black font-weight-bold">Billable</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <CompanyOrderList></CompanyOrderList>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required,minLength} from 'vuelidate/lib/validators';
    // import {EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    // import DatePicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';
    // import {BASE_API} from '@/axios';
    import CompanyOrderList from '@/views/company/company-personal-cabinet/CompanyOrderList'

    export default {
        name: "CompanyPersonalCabinetEditView",
        components: {
            CompanyOrderList
        },
        data() {
            return {
                parseDate: parseDate,
                formatDate: formatDate,
                processing: false,
                loading: {
                    isDocQrLoading: false,
                },
                ownerFilter: initFilterModel(),
                editIndex: null,
                loadingExcelCalc: false,
                companyTariff: {
                    id: null,
                    name: null,
                    qty: null,
                    amount: null,
                    measurementType: null,
                    description: null,
                },
                itemFilter: initFilterModel(),
                results: null
            }
        },
        validations() {
            return {
                companyTariff: {
                    companyTariffType: {
                        required: required
                    },
                    name: {
                        required: required
                    },
                    qty: {
                        required: required
                    },
                    amount: {
                        required: required
                    },
                    measurementType: {
                        required: required
                    },
                    description: {
                        required: required,
                        minLength: minLength(5)
                    },

                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (id && id > 0) {
                    this.$http.get('/companies-tariff/' + id)
                        .then(res => {
                            console.log(res);
                            vm.companyTariff = res.data;
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.fixedExpense.error'),
                                type: 'error'
                            });
                            this.processing = false;
                        })

                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('/companies-tariff/save', this.companyTariff)
                    .then(res => {
                        console.log(res)
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.companyTariff.success'),
                            type: 'success'
                        });
                        this.$router.push('/config/companies-tariff');
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.companyTariff.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })

            },
            cancel() {
                this.$router.push('/config/companies-tariff');
            },

        },
        computed: {

        },
        created() {
           this.init();
        }
    }
</script>

<style scoped>
    .custom {
        font-family: "Trebuchet MS",Arial,Helvetica,sans-serif;
        border-collapse: collapse;
        width: 100%;
    }
    .custom td,.custom th{
        border: 1px solid #ddd;
        padding: 4px;
    }
    .custom tr:nth-child(even){
        background-color: #f2f2f2;
    }
    .custom tr:hover{
        opacity: 1;
        background-color: #dee2e6;
    }
    .custom thead tr th{
        border-bottom-width: 1px;
        padding-top: 4px;
        padding-bottom: 4px;
        text-align: center !important;
        color: #9A9A9A;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 400;
    }
    .custom tr{
        font-size: 14px;
    }

</style>